import DetectionsEditor from './DetectionsEditor';

export default DetectionsEditor;
